import http from '@/services/api/http';

export default {
  getMarket(marketId, commentThreadId = '') {
    if (commentThreadId) {
      return http.get(`api/Market/${marketId}?commentThreadId=${commentThreadId}`);
    }
    return http.get(`api/Market/${marketId}`);
  },
  getCommentThread({ marketId, threadId }) {
    return http.get(`api/Market/${marketId}/CommentThread/${threadId}`);
  },
  getMarketTopComments(marketId) {
    return http.get(`api/Market/${marketId}/TopComments`);
  },
  getMarketRules(marketId) {
    return http.get(`api/Market/${marketId}/Rule`);
  },
  getContract(contractId) {
    return http.get(`api/Market/Contract/${contractId}`);
  },
  getRelatedContracts(contractId) {
    return http.get(`api/Market/${contractId}/RelatedContracts`);
  },
  getMarketContracts(marketId) {
    return http.get(`api/Market/${marketId}/Contracts`);
  },
  getMarketContractsStats(marketId) {
    return http.get(`api/Market/${marketId}/Contracts/Stats`);
  },
  getMarketRelated(marketId) {
    return http.get(`api/Market/${marketId}/Related`);
  },
  getMarketRelatedProducts(marketId) {
    return http.get(`/api/Market/${marketId}/RelatedProducts`);
  },
};
